module.exports = __webpack_public_path__ + "static/media/76.bb318e89.jpg";